import * as actions from "./jenisDokumen.actions";
import * as types from "./jenisDokumen.actionTypes";
import { ActionType, createReducer } from "typesafe-actions";
import { JenisDokumenReducerType } from "./types";

export type JenisDokumenActions = ActionType<typeof actions>;

export const initialState: JenisDokumenReducerType = {
  error: null,
  isLoading: false,
  errorMessage: '',
  redirectQueue: '',
  listJenisDokumen: [],
  selectedJenisDokumen: null,
};

export const JenisDokumenReducer = createReducer<
JenisDokumenReducerType,
  JenisDokumenActions
>(initialState)
  // GET JENIS DOKUMEN
  .handleAction(actions.getJenisDokumenAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: '',
  }))

  .handleAction(actions.getJenisDokumenAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    errorMessage: '',
    listJenisDokumen: action.payload.data.items,
  }))

  .handleAction(actions.getJenisDokumenAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // GET JENIS DOKUMEN
  .handleAction(actions.getDetailJenisDokumenAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: '',
  }))

  .handleAction(actions.getDetailJenisDokumenAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    errorMessage: '',
    selectedJenisDokumen: action.payload.data,
  }))

  .handleAction(actions.getDetailJenisDokumenAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // UPDATE JENIS DOKUMEN
  .handleAction(actions.updateJenisDokumenAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: '',
    errorMessage: '',
  }))

  .handleAction(actions.updateJenisDokumenAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
    redirectQueue: '/jenis-dokumen',
  }))

  .handleAction(actions.updateJenisDokumenAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    redirectQueue: '',
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // CREATE JENIS DOKUMEN
  .handleAction(actions.createJenisDokumenAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: '',
    errorMessage: '',
  }))

  .handleAction(actions.createJenisDokumenAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
    redirectQueue: '/jenis-dokumen',
  }))

  .handleAction(actions.createJenisDokumenAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    redirectQueue: '',
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // OTHER SELECTORS
  .handleAction(types.INITIALIZE_CREATE_JENIS_DOKUMEN as any, (state, action) => ({
    ...state,
    selectedJenisDokumen: action.payload.jenisDokumen,
  }))

  .handleAction(types.SELECT_JENIS_DOKUMEN as any, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    redirectQueue: '',
    selectedJenisDokumen: action.payload.jenisDokumen,
  }))

  .handleAction(types.UPDATE_NAME as any, (state, action) => ({
    ...state,
    selectedJenisDokumen: (() => {
      if (state.selectedJenisDokumen) {
        return {
          ...state.selectedJenisDokumen,
          DOK_JENIS_NAMA: action.payload.name
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_STATUS as any, (state, action) => ({
    ...state,
    selectedJenisDokumen: (() => {
      if (state.selectedJenisDokumen) {
        return {
          ...state.selectedJenisDokumen,
          STATUS: action.payload.status
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_KODE as any, (state, action) => ({
    ...state,
    selectedJenisDokumen: (() => {
      if (state.selectedJenisDokumen) {
        return {
          ...state.selectedJenisDokumen,
          DOK_JENIS_KODE: action.payload.kode
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_PARENT as any, (state, action) => ({
    ...state,
    selectedJenisDokumen: (() => {
      if (state.selectedJenisDokumen) {
        return {
          ...state.selectedJenisDokumen,
          DOK_JENIS_PARENT: action.payload.newId,
          DOK_JENIS_PARENT_DETAIL: action.payload.newDetail
        };
      } else {
        return null;
      }
    })(),
  }));
